
import { iSelectProps, iSelectVariants } from '@/types/components';
import { memo } from 'react';
import AsyncDropdownWithTitle from './async-dropdown-with-title';
import AsyncFloatingDropdown from './async-floating-dropdown';

import DropdownWithTitle from './dropdown-with-title';
import FloatingDropdown from './floating-dropdown';

const Select = (props: iSelectProps & {variant: iSelectVariants }) => {
  const { variant, ...rest } = props;
  const variants: Record<iSelectVariants, JSX.Element> = {
    floatingdropdown: <FloatingDropdown key={rest.id} {...rest} />,
    // @ts-expect-error comment
    asyncfloatingdropdown: <AsyncFloatingDropdown key={rest.id} loadoptions={props.loadedOptions} {...rest}/>,
    dropdownwithtitle: <DropdownWithTitle {...rest}/>,
    // @ts-expect-error comment
    asyncdropdownwithtitle: <AsyncDropdownWithTitle key={rest.id} loadoptions={props.loadedOptions} {...rest}/>
  };

  const RenderedComponent = variants[variant];
  return <>
    {RenderedComponent}
  </>; 
};

export default memo(Select);
